import { render, staticRenderFns } from "./HighLightText.vue?vue&type=template&id=cce12448&scoped=true&"
import script from "./HighLightText.vue?vue&type=script&lang=ts&"
export * from "./HighLightText.vue?vue&type=script&lang=ts&"
import style0 from "./HighLightText.vue?vue&type=style&index=0&id=cce12448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce12448",
  null
  
)

export default component.exports